import { HeartPulse, Globe2, Users, Siren } from "lucide-react";
import { Reveal } from "./Reveal";
import TopicsStrip from "./TopicsStrip";
import ResourceHub from "./ResourceHub";
import { useLang } from "@/lib/i18n";

const ICONS = [
  { icon: HeartPulse, accent: "#0057B7" },
  { icon: Globe2, accent: "#E11B22" },
  { icon: Users, accent: "#E11B22" },
  { icon: Siren, accent: "#0057B7" },
];

export default function Logistics() {
  const { t } = useLang();
  return (
    <section
      id="logistics"
      data-testid="logistics-section"
      className="relative border-t border-white/10 bg-[#0B0C10] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="mb-14 md:mb-20 max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#E11B22]">
            {t.log_label}
          </span>
          <h2 className="mt-5 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight">
            {t.log_title}
          </h2>
        </Reveal>

        {/* 4-quadrant wireframe grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 border-t border-l border-white/10">
          {t.log_boxes.map((b, i) => {
            const Icon = ICONS[i].icon;
            const accent = ICONS[i].accent;
            return (
              <Reveal
                key={i}
                delay={i * 0.08}
                className="group relative border-r border-b border-white/10 p-8 md:p-12 overflow-hidden"
                data-testid={`logistics-box-${i + 1}`}
              >
                <div
                  className="absolute -right-16 -top-16 h-40 w-40 rounded-full blur-3xl opacity-0 group-hover:opacity-30 transition-opacity duration-500"
                  style={{ background: accent }}
                />
                <div
                  className="relative flex h-14 w-14 items-center justify-center rounded-sm border border-white/15"
                  style={{ color: accent }}
                >
                  <Icon className="h-7 w-7" strokeWidth={1.5} />
                </div>
                <h3 className="relative mt-8 font-heading text-xl md:text-2xl font-medium text-white">
                  {b.title}
                </h3>
                <p className="relative mt-4 max-w-md text-sm sm:text-base leading-relaxed text-zinc-300">
                  {b.body}
                </p>
              </Reveal>
            );
          })}
        </div>

        <TopicsStrip />
        <ResourceHub />
      </div>
    </section>
  );
}
